<div class="grid">
  <div class="grid__col-sm-10 grid__col-xs-12 center-item center-text">
    <h1
      class="h1"
      tabindex="-1"
      dgxAutofocus
      [innerHTML]="onboarding_ReviewSkillsHeader"
    ></h1>
    <p
      class="par guts-p-t-1"
      [innerHTML]="onboarding_ReviewSkillsDescription"
    ></p>
  </div>
  <div class="grid__col-10 center-item">
    <dgx-skill-search class="guts-m-t-1 center-item"></dgx-skill-search>
    <dgx-skill-select-items
      *ngIf="showSuggestions"
      [showInterestedOnly]="true"
    ></dgx-skill-select-items>
  </div>
  <!-- hide this the toggle suggestions if there are no dispalyed sim skills-->
  <ng-container *ngIf="displayedSimilarSkills | async as similarSkills">
    <div
      class="grid__col-10 center-item"
      *ngIf="!showSuggestions && similarSkills.length > 0"
    >
      <a
        class="center-text color-blue par--small font-medium uhover"
        (click)="toggleSuggestions()"
        data-dgat="review-skills-aee"
      >
        {{ i18n.Onboarding_SeeSuggestedSkills }}
      </a>
    </div>
  </ng-container>
  <div *ngIf="displaySkills" class="grid__col-10 center-item guts-m-t-1">
    <dgx-data-table
      [columns]="columns"
      [items]="displaySkills"
    ></dgx-data-table>
  </div>
</div>

<ng-template #isFocusSkillColumnTemplate let-item>
  <button
    class="hover-color-blue"
    [ngClass]="{
      'color-warning': item.isFocused,
      'color-ebony-a18': !item.isFocused
    }"
    (click)="toggleFocused($event, item)"
    [ngbTooltip]="getFocusSkillI18n(item.isFocused)"
    [attr.aria-label]="getFocusSkillI18n(item.isFocused)"
    data-dgat="assigned-skills-bda"
  >
    <df-icon size="small" [icon]="'star'"></df-icon>
  </button>
</ng-template>

<ng-template #skillNameColumnTemplate let-item>
  <span [textContent]="item.title" class="ib-v-middle break"></span>
</ng-template>

<ng-template #selfRatingColumnTemplate let-item>
  <button
    class="ib horizontal-center"
    [ngbTooltip]="getTooltip(item)"
    (click)="handleAddTargetLevel($event, item)"
    [attr.aria-label]="getAriaLabel(item)"
    data-dgat="review-skills-709"
  >
    <dgx-tag-rating-donut
      class="rating-icon"
      size="sm"
      [highlight]="true"
      [isOwner]="true"
      [level]="getSelfRatingLevel(item).toString()"
      [showDefaultPlus]="true"
    ></dgx-tag-rating-donut>
  </button>
</ng-template>

<ng-template #sourceTemplate let-item>
  <span [textContent]="item.source" class="ib-v-middle"></span>
</ng-template>

<ng-template #removeTemplate let-item>
  <button
    class="action-options__button"
    (click)="removeTag(item)"
    data-dgat="review-skills-c83"
    [attr.aria-label]="'Core_RemoveSkill' | translate"
  >
    <df-icon
      [icon]="'cross'"
      class="action-options__button"
      size="small"
    ></df-icon>
  </button>
</ng-template>
